import {
  Dialog,
  DialogContent,
  Grid,
  DialogTitle,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  DialogActions
} from '@mui/material'
import { GreenText } from 'components'
import { vehicleDamageNoteValidationSchema } from 'dtos'
import { Formik } from 'formik'

interface DamageNoteAddDialogProps {
  initialValues: any
  open: boolean
  onClose: () => void
  onSave: (values: any) => void
  isLoading: boolean
}

export default function DamageNoteAddDialog({ open, onClose, onSave, isLoading, initialValues }: DamageNoteAddDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validateOnChange={true}
        validateOnBlur={false}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
        validationSchema={vehicleDamageNoteValidationSchema}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, submitCount, isSubmitting, setFieldValue, touched, values }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <Grid container spacing={2} alignItems='center'>
                <DialogTitle>Add Note</DialogTitle>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  disabled={isLoading || isSubmitting}
                  error={Boolean((touched.note || submitCount > 0) && errors.note)}
                  fullWidth
                  helperText={(touched.note || submitCount > 0) && typeof errors.note === 'string' ? errors.note : undefined}
                  label='Note'
                  maxRows={6}
                  minRows={6}
                  multiline
                  name='note'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.note || ''}
                />
              </Grid>
            </DialogContent>

            <Grid item xs={12} sx={{ p: 2 }}>
              <GreenText variant='outlined'>
                {`**Damage Description:**
                
Is a free-type text field that allows users to input additional notes or 
details about the vehicles reported damage

Max character count: 255 characters.

**CANCEL Button:**

Clicking the CANCEL button will close the dialog and not save any 
changes

**SAVE Button:**

Clicking the SAVE button will save any changes.                

`}
              </GreenText>
            </Grid>

            <DialogActions sx={{ justifyContent: 'flex-end', p: 2 }}>
              <Button variant='text' color='error' onClick={onClose}>
                CANCEL
              </Button>
              <Button type='submit' color='primary' variant='contained' disabled={isLoading || isSubmitting}>
                Save
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  )
}
